import { doc, DocumentData } from 'firebase/firestore'
import { useAuthState } from 'react-firebase-hooks/auth'
import { useDocumentData } from 'react-firebase-hooks/firestore'
import { Data } from 'react-firebase-hooks/firestore/dist/firestore/types'
import { firebaseAuth, firestore } from '../config/firebase'

export const USERS_COLLECTION = 'users'

/**
 * Returns firestore field data for the authenticated user.
 *
 * Returns `undefined` if no user has been authenticated or if the data is still
 * being fetched.
 *
 * Will trigger re-renders everytime the data gets updated via firestore's
 * `onSnapshot` method.
 */
export const useUserData = (): Data<DocumentData, '', ''> => {
  const [user] = useAuthState(firebaseAuth)

  const userDocRef = user
    ? doc(firestore, USERS_COLLECTION, user.uid)
    : undefined

  const [userData] = useDocumentData(userDocRef)
  return userData
}
